import React, { useContext, useEffect, useState } from "react";
import style from "./Messages.module.css";
import { BsPeople } from "react-icons/bs";
import Message from "./Message";
import Sendinput from "./Sendinput";
import { Chatcontext } from "../context/Chatcontext";
import { doc, getDoc, onSnapshot, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/config";
import { Authcontext } from "../context/Authcontext";
import { toast } from "react-toastify";
const Messages = () => {
  const chatcontext = useContext(Chatcontext);
  const [chat, setChat] = useState([]);
  const [chatname, setChatname] = useState("");
  const { currentuser } = useContext(Authcontext);

  const [roomUser, setRoomUser] = useState();
  useEffect(() => {
    const fetchRoomUser = async () => {
      try {
        const docRef = doc(db, "roomuser", chatcontext?.chatid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setRoomUser(docSnap?.data()?.users);
        } else {
          console.log("No such document!");
        //   toast.warning("There is something wrong.");
        }
      } catch (error) {
        console.error("Error fetching room user:", error);
        toast.error("Error fetching room user.");
      }
    };

    const fetchChat = () => {
      const unsubscribe = onSnapshot(
        doc(db, "messages", chatcontext.chatid),
        (doc) => {
          doc.exists() && setChat(doc.data());
        }
      );
      return unsubscribe;
    };

    const fetchChatUser = async () => {
      try {
        const docRef = doc(db, "roomuser", chatcontext?.chatid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setChatname(docSnap.data()?.name);
        } else {
          console.log("No such document!");
        }
      } catch (error) {
        console.error("Error fetching chat user:", error);
      }
    };

    const increaseUnreadMessages = async () => {
      try {
        console.log(roomUser,currentuser.uid)
        const docRef = doc(db, "roomuser", chatcontext?.chatid);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
        //   setRoomUser(docSnap?.data()?.users);
          const updatedUsers = docSnap?.data()?.users?.map((user) => {
            if (user.user_id === currentuser.uid) {
              return { ...user, un_read_message: 0 };
            }
            return user;
          });
          console.log(updatedUsers)
          updatedUsers &&  await updateDoc(doc(db, "roomuser", chatcontext?.chatid), {
            users: updatedUsers,
          });
        } else {
          console.log("No such document!");
        //   toast.warning("There is something wrong.");
        }


        // await fetchRoomUser();
      } catch (error) {
        console.error("Error increasing unread messages:", error);
      }
    };

    // Execute the asynchronous functions
    // fetchRoomUser();
    const unsubscribe = fetchChat();
    fetchChatUser();
    increaseUnreadMessages();

    // Cleanup function
    return () => unsubscribe();
  }, [chatcontext.chatid, currentuser?.uid]);

  return (
    <div className={style.messagescontainer}>
      <div className={style.messagesnav}>
        <div className={style.navcontent}>
          <p>{chatname}</p>
        </div>
        <div className={style.cardicon}>
          <BsPeople size={36} />
        </div>
      </div>
      <div className={style.message}>
        {chat?.message &&
          chat?.message?.map((m) => {
            return <Message key={m.id} message={m} />;
          })}
      </div>
      <Sendinput />
    </div>
  );
};
export default Messages;
